import { UtilMasks } from 'src/app/utils/util-masks';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-resumo-resultado',
  templateUrl: './resumo-resultado.component.html',
  styleUrls: ['./resumo-resultado.component.scss']
})
export class ResumoResultadoComponent implements OnInit {
  @Input() cabecalho;
  @Input() consulta;

  title = "RESUMO CRÉDITO";
  classificacao;
  score;
  alerts: any;
  resumoCredito = <any>{};

  mask = {
    documento: { mask: UtilMasks.documento, guide: false },
  }


  constructor() { }

  ngOnInit() {
    this.inicializaFunctions();
  }

  inicializaFunctions() {
    this.formatResumo(this.cabecalho);
    this.setAlertas();
  }

  formatResumo(dados) {
    let result;
    let consultas = dados.consultas;

    consultas.filter(c => {
      dados.consultas.forEach(e => {
        if (e.tipoConsulta == c.tipoConsulta) {
          result = e.consulta
        }
      });
    });

    this.resumoCredito = {
      nome: this.cabecalho.dadosResumoCredito.nome ? this.cabecalho.dadosResumoCredito.nome : result.razao_social ? result.razao_social : 'NÃO INFORMADO',
      cpf_cnpj: this.cabecalho.dadosResumoCredito.cpfcnpj ? this.cabecalho.dadosResumoCredito.cpfcnpj : result.cnpj ? result.cnpj : 'NÃO INFORMADO',
      endereco: this.cabecalho.dadosResumoCredito.endereco ? this.cabecalho.dadosResumoCredito.endereco :
        result.endereco.logradouro ?
          result.endereco.logradouro + ', ' +
          result.endereco.bairro + ', ' +
          result.endereco.cidade + ' - ' +
          result.endereco.uf :
          'NÃO INFORMADO',
      usuario: dados.usuario ? dados.usuario : 'NÃO INFORMADO',
      unidade: dados.unidade ? dados.unidade : 'NÃO INFORMADO',
      data_criacao: dados.dataCriacao ? dados.dataCriacao : 'NÃO INFORMADO',
      tokenConsulta: dados.tokenConsulta ? dados.tokenConsulta : 'NÃO INFORMADO',
      codigo_consulta: dados.id ? dados.id : 'NÃO INFORMADO'
    }

    if (result.score) {
      this.setScore(result.score);
    }
  }

  setAlertas() {
    const a = this.cabecalho.dadosResumoCredito.alertas;

    this.alerts = [
      { qtd: a.qtdCcf || 'Sem detalhamento', total: a.vlrCcf || 'Sem detalhamento', label: 'EMITENTES DE CHEQUES SEM FUNDO' },
      { qtd: a.qtdChequeContraOrdem || 'Sem detalhamento', total: a.vlrChequeContraOrdem || 'Sem detalhamento', label: 'CHEQUE - ORDEM - OCORRÊNCIAS' },
      { qtd: a.qtdConsultasAnterioresSintetico || 'Sem detalhamento', total: a.vlrConsultasAnterioresSintetico || 'Sem detalhamento', label: 'CONSULTAS ANTERIORES - SINTÉTICO' },
      { qtd: a.qtdDividasVencidas || 'Sem detalhamento', total: a.vlrDividasVencidas || 'Sem detalhamento', label: 'DÍVIDAS VENCIDAS' },
      { qtd: a.qtdPendenciasFinanceiras || 'Sem detalhamento', total: a.vlrPendenciasFinanceiras || 'Sem detalhamento', label: 'PENDÊNCIAS FINANCEIRAS' },
      { qtd: a.qtdProtestos || 'Sem detalhamento', total: a.vlrProtestos || 'Sem detalhamento', label: 'PROTESTOS ESTADUAIS' },
      { qtd: a.qtdRegistroScpcBvs || 'Sem detalhamento', total: a.vlrRegistroScpcBvs || 'Sem detalhamento', label: 'REGISTRO SCPC BVS' },
      { qtd: a.qtdRestricoesFinanceiras || 'Sem detalhamento', total: a.vlrRestricoesFinanceiras || 'Sem detalhamento', label: 'RESTRIÇÕES FINANCEIRAS' },
      { qtd: a.qtdControleSocietario || 'Sem detalhamento', total: a.vlrControleSocietario || 'Sem detalhamento', label: 'CONTROLE SOCIETÁRIO' },
      { qtd: a.qtdParticipacaoEmpresas || 'Sem detalhamento', total: a.vlrParticipacaoEmpresas || 'Sem detalhamento', label: 'PARTICIPAÇÕES EMPRESAS' },
      { qtd: a.qtdConsultasAnterioresAnalitico || 'Sem detalhamento', total: 'Sem detalhamento', label: 'CONSULTAS ANTERIORES - ANALÍTICO' },
      { qtd: a.qtdConsultasAnteriores || 'Sem detalhamento', total: 'Sem detalhamento', label: 'CONSULTAS ANTERIORES' },
      { qtd: a.qtdChequeSemFundo || 'Sem detalhamento', total: a.vlrChequeSemFundo || 'Sem detalhamento', label: 'CHEQUES SEM FUNDO' },
    ].map(v => {
      v.qtd = v.qtd == 'Não informado' ? 'Sem detalhamento' : v.qtd;
      return v;
    }).filter(v => v.qtd != 'Sem detalhamento');

  }

  setScore(score) {
    this.score = score;
  }

}
